import { useRef, useEffect } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text } from "@izettle/react"

import { PageWrapper } from "@/components/layout-helpers"
import { PreviewImage } from "@/components/preview-image"

const UploadText = styled(Text.RegularBold)`
  margin-top: ${spacing.none};
  text-align: center;
`

type DocumentIsUploadingProps = {
  alt?: string
  previewImgURL: string | undefined
  isPDF: boolean
}

export const DocumentIsUploading: React.FC<DocumentIsUploadingProps> = ({
  alt,
  previewImgURL,
  isPDF,
}) => {
  const { text } = useLocalization()
  const wrapperElementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    wrapperElementRef?.current?.focus()
  }, [wrapperElementRef?.current])

  return (
    <PageWrapper>
      <PreviewImage alt={alt} imgUrl={previewImgURL} isPDF={isPDF} showOverlay/>
      <UploadText ref={wrapperElementRef} tabIndex={0} aria-live="polite">
        {text("UPLOADING_DOCUMENT")}
      </UploadText>
    </PageWrapper>
  )
}
